<template>
  <v-container fluid class="px-0 py-0 mx-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-media>
            <img src="./../assets/home_background.png" style="width:100%;height:100%;max-height:400px;object-fit:cover;"
            />
          </v-card-media>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="elevation-10">
          <v-container grid-list-xl class="px-4 py-0">
            <v-layout row wrap>
              <v-flex xs12 class="py-2">
                <v-card-text>
                  <p class="text-xs-center subheading mb-0">PRODUCTOS SUBIDOS</p>
                </v-card-text>
              </v-flex>
            </v-layout>
            <grid :products="products" :editMode="false"></grid>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import HTTP from '@/axios-config'
import Grid from '@/components/Grid'

export default {
  components: {
    Grid
  },
  name: 'Home',
  data () {
    return {
      products: []
    }
  },
  created () {
    let category = this.$store.getters.getCategory
    if (category) this.getProductsByCategory(category)
    else this.getProducts()

    this.$bus.$on('event-getProductsByCategory', (category) => {
      if (category) this.getProductsByCategory(category)
      else this.getProducts()
    })
  },
  methods: {
    getProducts () {
      HTTP.get('/product/getAll')
        .then(function (response) {
          this.products = response.data.result
        }.bind(this))
        .catch(function (error) {
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    },
    getProductsByCategory (category) {
      HTTP.post('/product/getProductsByCategory', {
        category: category
      })
        .then(function (response) {
          this.products = response.data.result
        }.bind(this))
        .catch(function (error) {
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    }
  }
}

</script>

<!-- Add "scoped " attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue